import React from 'react';
import CommitteeSection from '../components/committee/CommitteeSection';
import './CommitteePages.css';

const members = [
];

const InternationalOrganizingCommitteePage = () => (
  <CommitteeSection heading="International Organizing Committee" members={members} />
);

export default InternationalOrganizingCommitteePage;
